<div class="login-signup-box popout" id="otp-verification-container">
  <div class="modal-body cstm_modal_Nmodal">
    <button type="button" class="close circle-css" (click)="closeDialog()" aria-label="Close dialog">
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="heading_modal">
      <h3 id="otp-verification-title">{{title}}</h3>
    </div>

    <div class="form-group">
      <label for="verifyMobile" class="font-weight-bold">Mobile Number</label>
      <button type="button" [hidden]="!mobileVerification.token" (click)="mobileVerification.token = null" class="btn btn-link p-0 ml-2" style="font-size: 14px; text-decoration: underline;">Change
        Number</button>
      <div class="text-box-wrap">
        <input class="form-control" id="verifyMobile" type="tel" numberOnly maxlength="10" placeholder="Mobile number"
          autocomplete="tel" [(ngModel)]="mobileVerification.mobile"
          [disabled]="mobileVerification.token">
      </div>
    </div>
    <br>
    <div [hidden]="!mobileVerification.token">
      <label for="verifyOtp" class="font-weight-bold">Enter OTP</label>
      <div class="text-box-wrap">
        <input class="form-control" id="verifyOtp" numberOnly type="text" maxlength="4" placeholder="4-digit OTP"
          autocomplete="one-time-code" [(ngModel)]="mobileVerification.otp">
      </div>
      <button type="button" class="btn btn-link p-0" style="font-size: 14px; text-decoration: underline;" (click)="getOtp(false)">Resend OTP</button><br />
      <button type="button" class="btn btn-link p-0" style="font-size: 14px; text-decoration: underline;" (click)="getOtp(true)">Get OTP via call</button>
    </div>

    <div>
      <button type="button" (click)="getOtp(false)" class="app-btn btn btn-danger" [hidden]="mobileVerification.token"
        [disabled]="nullOrEmpty(mobileVerification.mobile, 10)">
        Get OTP
      </button>
      <button type="button" (click)="validateOtp()" class="app-btn btn btn-danger" [hidden]="!mobileVerification.token"
        [disabled]="nullOrEmpty(mobileVerification.otp, 4)">
        Verify OTP
      </button>
    </div>

  </div>
</div>